// src/components/organizer/layout/OrganizerLayout.jsx
import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrganizerProfile, silentRefreshOrganizer } from "@/store/slices/organizerSlice";
import OrganizerSidebar from "./OrganizerSidebar";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import Loading from "@/components/common/Loading";

const OrganizerLayout = () => {
  const [collapsed, setCollapsed] = React.useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, organizer, isLoading } = useSelector((state) => state.organizer);

  useEffect(() => {
    // Attempt silent refresh on layout mount to restore session
    if (!isAuthenticated && !organizer) {
      dispatch(silentRefreshOrganizer());
    }
  }, [dispatch, isAuthenticated, organizer]);

  useEffect(() => {
    // Once authenticated, fetch full profile if not loaded
    if (isAuthenticated && !organizer && !isLoading) {
      dispatch(fetchOrganizerProfile());
    }
    // If not loading and not authenticated, redirect to login
    if (!isLoading && !isAuthenticated) {
      navigate("/organizer/login");
    }
  }, [dispatch, navigate, organizer, isAuthenticated, isLoading]);

  if (isLoading && !organizer) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <Loading />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
      <Header />

      <div className="flex flex-1 pt-[72px]">
        <OrganizerSidebar collapsed={collapsed} setCollapsed={setCollapsed} />

        <div className="flex-1 flex flex-col min-w-0">
          <main className="flex-1 p-6 md:p-8">
            <div className="max-w-[1300px] mx-auto">
              <Outlet />
            </div>
          </main>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default OrganizerLayout;
